import React from 'react';

export default ({handleEditClick, applicationStatus, handleBackButtonClick, applicationId, loadInProgress}) => {

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div className='go-back-to-list-header-button' onClick={handleBackButtonClick}>Back</div>
      <header>
        Oil Formulation Details
      </header>
      {!loadInProgress &&
        <React.Fragment>
          <div className={`detailsScene__status-label ${applicationStatus.toLowerCase()}`}>{applicationStatus.toLowerCase()}</div>
        </React.Fragment>
      }
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Edit/Header.jsx